import { useCallback, useRef } from 'react';
import usePmProvider from 'components/hooks/PM/usePmProvider';
import {
  filterTabByGitProvider,
  filterTabByPmProvider,
  filterTabByAccountType,
  filterByFeatureFlag,
  filterTabByCondition
} from './tabsBuilder.filters';
import { useSelector } from 'react-redux';
import { myAccountSelector } from 'state/selectors/account';
import useSettingsService from 'components/hooks/useSettingsService';
import { gitIntegrationsSelector } from 'state/selectors/sensors-authorizations';

const useTabsBuilder = () => {
  const tabsRef = useRef([]);

  const { getSettingOrDefinitionValue } = useSettingsService();
  const pmProvider = usePmProvider();
  const giIntegrations = useSelector(gitIntegrationsSelector) || [];
  const gitProvider = giIntegrations.map(({ sensor_id }) => sensor_id);
  const account = useSelector(myAccountSelector);
  const accountType = account.type_id;

  /**
   * @param {[RouterTab]} tabs
   * @returns {void}
   */
  const initTabs = tabs => (tabsRef.current = tabs);

  const filterTabs = tabs => {
    return tabs
      .filter(tab => filterByFeatureFlag(tab, getSettingOrDefinitionValue))
      .filter(tab => filterTabByPmProvider(tab, pmProvider))
      .filter(tab => filterTabByGitProvider(tab, gitProvider))
      .filter(tab => filterTabByAccountType(tab, accountType))
      .filter(filterTabByCondition);
  };

  const build = useCallback(() => {
    const filteredTabs = filterTabs(tabsRef.current);
    filteredTabs.forEach(entry => {
      entry.menu = entry.menu && filterTabs(entry.menu);
    });
    return filteredTabs;
  }, [tabsRef.current]);

  return {
    initTabs,
    build
  };
};

export default useTabsBuilder;
